import React from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function Footer() {
  return (
    <footer className="border-t border-parchment/8 py-8">
      <div className="max-w-8xl mx-auto px-8 md:px-14 flex flex-col md:flex-row items-center justify-between gap-4">
        <AppLogo
          text="Knxckout Media"
          size={20}
          className="font-serif text-parchment/30 tracking-[0.22em] text-xs font-light"
        />
        <div className="flex items-center gap-6 text-parchment/30 text-xs tracking-[0.08em]">
          <span>© 2026 Knxckout Media. All rights reserved.</span>
        </div>
        <div className="flex items-center gap-5">
          <a
            href="https://www.instagram.com/knxckout.media/"
            className="text-xs tracking-[0.08em] text-parchment/30 hover:text-gold transition-colors duration-300"
          >
            Instagram
          </a>
        </div>
      </div>
    </footer>
  );
}